export const styles = {
  orContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'center',
    marginTop: '24px',
    marginBottom: '24px',
  },

  orLine: {
    flexGrow: 1,
    height: '0.5px',
    backgroundColor: '#BEBED6',
  },
  orText: {
    margin: '0 10px',
    color: '#BEBED6',
  },
}
